// src/pages/CommunityHome.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../firebase";
import { doc, getDoc, collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { useAuth } from "../../rbac/AuthContext";
import { Container, Button, Alert } from "react-bootstrap";

export default function CommunityHome() {
  const { communityId } = useParams();
  const { currentUser, role, communities } = useAuth();
  const [community, setCommunity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMember, setIsMember] = useState(false);
  const [requestSent, setRequestSent] = useState(false);

  useEffect(() => {
    const fetchCommunity = async () => {
      try {
        const docRef = doc(db, "communities", communityId.toLowerCase());
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setCommunity(data);

          if (data.members && data.members.includes(currentUser?.uid)) {
            setIsMember(true);
          } else {
            const q = query(
              collection(db, "joinRequests"),
              where("communityId", "==", communityId.toLowerCase()),
              where("userId", "==", currentUser?.uid)
            );
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
              setRequestSent(true);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching community:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCommunity();
  }, [communityId, currentUser]);

  const handleJoinRequest = async () => {
    try {
      await addDoc(collection(db, "joinRequests"), {
        communityId: communityId.toLowerCase(),
        userId: currentUser.uid,
        userEmail: currentUser.email,
        status: "pending",
        createdAt: new Date()
      });
      setRequestSent(true);
      alert("Join request sent!");
    } catch (error) {
      console.error("Error sending join request:", error);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!community) return <p>Community not found</p>;

  return (
    <Container className="mt-4">
      <h2>{community.name}</h2>
      <p>{community.description || "No description available"}</p>
      <p><strong>Manager:</strong> {community.managerEmail}</p>

      {role === "manager" && communities.includes(communityId.toLowerCase()) ? (
        <Alert variant="success">You are the manager of this community.</Alert>
      ) : isMember ? (
        <Alert variant="success">You are a member of this community.</Alert>
      ) : requestSent ? (
        <Alert variant="info">Join request already sent. Waiting for approval.</Alert>
      ) : (
        <Button variant="primary" onClick={handleJoinRequest}>
          Request to Join
        </Button>
      )}
    </Container>
  );
}